<template>

    <div>
       
        <div class="info" v-if="baseInfo != null">
            <div class="row">
                <div class="col-12 col-lg-4">
                    <span class="title">آدرس: </span> <span class="text-all">{{baseInfo.Address}}</span>
                </div>
                <div class="col-12 col-lg-2">
                    <span class="title">شماره تماس: </span> <span class="text-all">
                    <div  style="display: flex; flex-direction: column; margin-top: 10px; margin-top: -24px; margin-right: 183px; ">
                        <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo }}</a>
                   <a href="tel:04135515462">04135515462</a>
                        </div>
                    </span>
                </div>
                <div class="col-12 col-lg-3">
                    <span class="title">ایمیل: </span><a :href="'mailto:' + baseInfo.Email ">{{ baseInfo.Email }}</a>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="socials">
                        <div class="footer-social">
                            <a v-if="baseInfo.InstagramLink != null && baseInfo.InstagramLink != ''" :href="baseInfo.InstagramLink" :title="' اینستاگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-instagram"></i> اینستاگرام</a>
                            <a v-if="baseInfo.TelegramLink != null && baseInfo.TelegramLink != ''" :href="baseInfo.TelegramLink" class="margin" :title="' تلگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-telegram"></i> تلگرام</a>
                            <a v-if="baseInfo.AparatLink != null && baseInfo.AparatLink != ''" :href="'https://api.whatsapp.com/send?phone=' + baseInfo.AparatLink" class="margin" :title="' واتساپ ' + baseInfo.ShopName" target="_blank"><i class="fa fa-whatsapp"></i> واتساپ</a>
                            <a  href="https://rubika.ir/irannmart" :title="' روبیکا ' + baseInfo.ShopName" target="_blank"> <img style="width:25px" src="/assets/img/robika.png" /> روبیکا</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }
    }
</script>

<style scoped>
    .ai-center-fr {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        margin-top: 40px;
    }

    .footer-features {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
    }

    .socials .footer-social a i {
        color: #c1af4e;
        font-size: 18px;
    }

    .margin {
        margin: 0 5px 0 5px;
    }

    .div-image {
        display: inline-block;
    }

    .text-all {
        font-size: 14px;
        font-weight: bold;
    }
</style>